// CMS APIデータを加工する共通処理


import moment from "moment";

export namespace CmsApiUtil {

    // 名称データ ({jp:'ラーメン', en:'Ramen'} フォーマット) から言語指定して名称を取り出す
    export function getName(names: { [lang: string]: string }, langCode: string): string {
        if (!names)
            return "";

        if (!(langCode in names))
            return "";

        return names[langCode];
    }

    export function dateToUI(date: string): Date {
        return moment(date).toDate();
    }

    export function dateToDB(date: Date): string {
        return moment(date).format("YYYY-MM-DD");
    }

    export function timeToUI(time: string): Date {
        if (!time)
            time = "00:00";

        return moment("1970-01-01 " + time).toDate();
    }

    export function timeToDB(time: Date): string {
        return moment(time).format("HH:mm");
    }


    export function isValidDatePeriod(startDateOnDB: string, endDateOnDB: string): boolean {
        // 時間未設定は仕様上許容する。そして、どちらかが未設定なら逆転は起こりえないので正しいと判定する
        if (!startDateOnDB || !endDateOnDB)
            return true;

        return dateToUI(startDateOnDB).getTime() <= dateToUI(endDateOnDB).getTime();
    }

    export function isValidTimePeriod(startTimeOnDB: string, endTimeOnDB: string): boolean {
        // 時間未設定は仕様上許容する。そして、どちらかが未設定なら逆転は起こりえないので正しいと判定する
        if (!startTimeOnDB || !endTimeOnDB)
            return true;

        return timeToUI(startTimeOnDB).getTime() <= timeToUI(endTimeOnDB).getTime();
    }

    export function isDuplicatePeriod(schedule: CMS.Schedule, scheduleList: CMS.Schedule[]): boolean {
        let start_date = schedule.start_date === '' ? '' : schedule.start_date;
        let start_time = schedule.start_time === '' ? '' : schedule.start_time;

        for (let i = 0; i < scheduleList.length; i++) {
            if (schedule.id === scheduleList[i].id) continue;
            if (start_date === scheduleList[i].start_date && start_time === scheduleList[i].start_time) {
                return false;
            }
        }

        return true;
    }

    export function isDuplicateDay(schedule: CMS.Schedule, scheduleList: CMS.Schedule[]): boolean {
        let start_time = schedule.start_time === '' ? '' : schedule.start_time;

        for (let i = 0; i < scheduleList.length; i++) {
            if (schedule.id === scheduleList[i].id) continue;
            if (schedule.designated_date === scheduleList[i].designated_date && start_time === scheduleList[i].start_time) {
                return false;
            }
        }

        return true;
    }

}
